module.exports = __webpack_public_path__ + "img/rule-SBCD.b20ff10a.svg";